module.exports = __webpack_public_path__ + "img/oneRed.aace77c1.png";